/*
 * @Author: liujiang liujiang@shjinjia.com.cn
 * @Date: 2022-12-19 17:52:59
 * @LastEditors: wangqi angelqiqiwang@shjinjia.com.cn
 * @LastEditTime: 2024-08-21 16:01:20
 * @FilePath: \oak\src\store\modules\routerMap\views\systemOperation.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
const map = {
  // 系统运维
  outInWarehouse: () => import('@/views/systemOperation/OutInWarehouse'), // 出入库查漏
  billingList: () => import('@/views/systemOperation/BillingList'), //  结算账单列表
  billingDetail: () => import('@/views/systemOperation/BillingDetail'), //  结算账单详情
  markingStyle: () => import('@/views/systemOperation/MarkingStyle'), //  打标
  inventoryLedgerList: () =>
    import('@/views/systemOperation/InventoryLedgerList'), // 库存台账一览
  ncPriorDataList: () => import('@/views/systemOperation/NcPriorDataList'), // NC先验数据一览
  checkDayList: () => import('@/views/systemOperation/CheckDayList'), // 日账单
  documentsList: () => import('@/views/systemOperation/DocumentsList'), // 单据一览
  // systemHealthMonitoring: () =>import('@/views/systemOperation/SystemHealthMonitoring'), //系统健康度监测
  systemHealthMonitoring: () =>
    import('@/views/systemOperation/SystemHealthMonitoring'), // 系统健康度监测
  systemLog: () => import('@/views/systemOperation/SystemLog'), // 系统日志
  systemRepair: () => import('@/views/systemOperation/SystemRepair'), // 系统问题修复
  systemMonitor: () => import('@/views/systemOperation/systemMonitor'), // 系统监控
  cStoreBillType: () => import('@/views/systemOperation/cStoreBillType'), // C店账单类型对应关系
  basicDataTblSync: () => import('@/views/systemOperation/BasicDataTblSync'), // 基础信息表同步
  callLimitTraffic: () => import('@/views/systemOperation/CallLimitTraffic'),
  documentTemplate: () => import('@/views/systemOperation/DocumentTemplate'),
  menuAdministration: () =>
    import('@/views/systemOperation/MenuAdministration'), // 菜单管理
  ncProcessingProgress: () => import('@/views/systemOperation/NcProcessingProgress'), // nc处理进度
  ncManualAdjustmentReceivable: () =>
    import('@/views/systemOperation/NcManualAdjustmentReceivable'), // NC手动调整验收单
  revenueAndExpenseList: () => import('@/views/systemOperation/revenueAndExpense/RevenueAndExpenseList'), // 收支项目列表
  platformSummary: () => import('@/views/systemOperation/revenueAndExpense/PlatformSummary'), // 平台收支汇总
  // 销售策略
  salesRulesConfig: () => import('@/views/systemOperation/SalesRulesConfig'),
  salesRulesConfigDetail: () => import('@/views/systemOperation/SalesRulesConfig/Detail')
}

export default map
